/** @jsx h */

const TeaserGlobal = ({ result }) => (
    <article className="search-result__article">
      <a className="microcard" href={result.url} {...(result.isExternal
                  ? { target: '_blank', rel: 'noopener' }
                  : '')}>
        <div className="microcard__inner">
          <div className="microcard__image">
          {result.image && (
            <img className="microcard__image__img"
                src={result.image.src}
                alt={result.image.alt}
                title={result.image.title}/>
          )}
          </div>
          <div className="microcard__bottom">
            <div className="microcard__headline">
              <h3 className="headline headline--3">{result.title}</h3>
            </div>
            <div className="microcard__icons">
              <span className="microcard__icons__item">
                <svg className="icon icon--arrow-right" viewBox="0 0 200 200" role="presentation">
                  <use href="#icon-arrow-right"></use>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </a>
    </article>
);

export default TeaserGlobal;